module.exports = __webpack_public_path__ + "img/file-done.b6bf0e75.svg";